import {PrecioGenericViewModel} from '@utils/ViewModels';

export const PRECIO_PRINT_WIDTH = '550px';

export interface Grupo {
  Grupo: string;
  Precios: Precio[];
}

export interface Precio {
  Superior: string;
  Inferior: string;
  Precio: number;
  Moneda: string;
  Varianza: number;
  Fecha: string | Date;
  PrecioRAW?: PrecioGenericViewModel;
  SaltoLinea: boolean;
  FechaRaw: number;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/general-interfaces.ts